module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0095.png.6ebb5751.jpg";